import { render, staticRenderFns } from "./TransferProjectToProjectModal.vue?vue&type=template&id=532e4ca8"
import script from "./TransferProjectToProjectModal.vue?vue&type=script&lang=js"
export * from "./TransferProjectToProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports